/* app/ui/nav/small */

define(
	'app/ui/nav/small',[
		'jquery',
		'pubsub',

	],
	function($) {

		var NavSmall;
		var $nav;
		var classes;
		var selectors;

		var $navItems;
		var $navLinks;
		var $navToggle;
		var $navBackLink;
		var elementsInit = false;

		return {
			init: function($elm, selectorList, classList) {
				NavSmall = this;
				$nav = $elm;
				selectors = selectorList;
				classes = classList;

				NavSmall._initElements();
				NavSmall._initSubscriptions();
				NavSmall._initEvents();
			},

			_initElements: function () {
				if (!elementsInit) {
					$navItems = $nav.find(selectors.navItem);
					$navLinks = $nav.find('.js-megamenu__heading');
					$navToggle = $('.js-header__nav-toggle');
					$navBackLink = $('.js-megamenu-back');
					elementsInit = true;
				}
			},

			_initSubscriptions: function() {
				$.subscribe('/nav/searchToggle', NavSmall._closeNav);
				$.subscribe('/nav/langToggle', NavSmall._closeNav);
			},

			_initEvents: function() {
				$navToggle.on('click', NavSmall._toggleSmallMenu);
				$navLinks.on('click', NavSmall._openSubMenu);
				$navBackLink.on('click', NavSmall._navGoBack);
			},

			unbind: function () {
				$.unsubscribe('/nav/searchToggle', NavSmall._closeNav);
				$.unsubscribe('/nav/langToggle', NavSmall._closeNav);
				$navToggle.off('click', NavSmall._toggleSmallMenu);
				$navLinks.off('click', NavSmall._openSubMenu);
				$navBackLink.off('click', NavSmall._navGoBack);
				NavSmall._resetMenu();
			},

			// close primary nav menu if open
			_closeNav: function () {
				if ($navToggle.hasClass(classes.expanded)) {
					$navToggle.trigger('click');
				}
			},

			// publish nav toggle event
			// show/hide primary nav menu dependant on current state
			// toggle class on menu button
			_toggleSmallMenu: function (event) {
				event.preventDefault();
				$.publish('/nav/navToggle');
				$nav.toggleClass(classes.expanded + ' ' + classes.collapsed);
				$navToggle.toggleClass(classes.expanded);

				if ($nav.hasClass(classes.collapsed)) {
					$nav.find('.' + classes.expanded).removeClass(classes.expanded);
				}
			},

			_openSubMenu: function (event) {
				event.preventDefault();
				var $link = $(this);
				var $item = $link.closest(selectors.navItem);

				//ajax call for next level menuitem
				if ($item.hasClass('js-ajax-navigation') && !$item.find('.js-sub-nav').length) {
					var url = $link.attr('data-nav-url');
					$.ajax({
							url: url
						})
						.done(function (data) {
							$link.after(data);
							var $subNav = $item.find('.js-sub-nav');
							setTimeout(function() { $item.toggleClass(classes.expanded); }, 100);
							$subNav.find('.js-megamenu-back').on('click', NavSmall._navGoBack);
							$subNav.find('.js-megamenu__heading').on('click', NavSmall._openSubMenu);
						});
					
				} else {
					$item.toggleClass(classes.expanded);
				}
			},

			// collapse nav and any expanded children
			_resetMenu: function() {
				$nav.removeClass(classes.expanded);
				$navItems.removeClass(classes.expanded);
				$navToggle.removeClass(classes.expanded);
			},

			_navGoBack:function(event) {
				var $target = $(event.target);
				var $megaMenuItem = $target.closest('.js-navigation__item--megamenu');
				if ($megaMenuItem.length) {
					$megaMenuItem.removeClass(classes.expanded);
				}
			}
		};
	}
);
